var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "#121622",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.00714L16.4929 7L12.5 10.9929L8.50714 7L7.5 8.00714L11.4929 12L7.5 15.9929L8.50714 17L12.5 13.0071L16.4929 17L17.5 15.9929L13.5071 12L17.5 8.00714Z",
    fill: "#D0D0D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.e7f7333e156d75463a09181245993605.svg";
export { ForwardRef as ReactComponent };